<template>
<div class="box integer">
  {{ findable.value }}
</div>  
</template>
<script>
export default {
  
  props: {
    findable: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>